<div class="account-info">

  <form *ngIf="matchingDupe" [action]="actionUrl" method="POST" #emailMatchForm>
    <input type="hidden" name="authenticity_token" [value]="csrfToken">
    <input type="hidden" name="user[login]" [value]="matchingDupe.found_user_uuid">
    <input type="hidden" name="user[user_duplicate_lookup_id]" [value]="matchingDupe.user_duplicate_lookup_id">
    <se-fe-alert seFeDataType="error">
      {{ matchingEmail }} is already in use on a SportsEngine account.
      <button seFeLink type="submit" (click)="emailMatchSignIn()">Sign in using this email</button>
    </se-fe-alert>
  </form>

  <header>
    <h5>CREATE ACCOUNT • STEP 1 OF 2</h5>
    <h3>
      Add Account Info
    </h3>
  </header>

  <div role="content">
    <div *ngIf="!ready">
      <se-fe-spinner [seFeDataSize]="900" [seFeDataInverted]="false" [seFeDataCenter]="true"></se-fe-spinner>
    </div>
    <form *ngIf="ready" [formGroup]="form" (ngSubmit)="submit()" novalidate>

      <se-fe-alert *ngIf="submitter.agelock" seFeDataType="error">
        You are not eligible to create a SportsEngine account.
        Please ask your parent or guardian to create an account.
      </se-fe-alert>

      <section>
        <se-fe-form-field [seFeDataConfig]="formConfig.firstName">
          <se-fe-form-field-text [seFeDataComfy]="comfy" formControlName="firstName"
            seFeDataAutoComplete="given-name"></se-fe-form-field-text>
        </se-fe-form-field>

        <se-fe-form-field [seFeDataConfig]="formConfig.lastName">
          <se-fe-form-field-text [seFeDataComfy]="comfy" formControlName="lastName"
            seFeDataAutoComplete="family-name"></se-fe-form-field-text>
        </se-fe-form-field>

        <div class="form-field">
          <se-fe-datepicker formControlName="dateOfBirth" [seFeDataComfy]="comfy"
            [seFeDataLabel]="formConfig.dateOfBirth.label" [seFeDataMessages]="formConfig.dateOfBirth.errorMessages"
            [seFeDataYearRange]="formConfig.dateOfBirth.yearRange"></se-fe-datepicker>
          <se-fe-form-control-help>
            <button type="button" class="popover-link" seFePopoverTrigger="dateOfBirthLearnMore" seFeLink>
              Learn more
            </button>
            <se-fe-popover seFePopoverName="dateOfBirthLearnMore">
              <p>If you are a parent/guardian signing up your child, add your name and date of birth here first.
                You'll have the opportunity to create your child's profile later.
              </p>
            </se-fe-popover>
          </se-fe-form-control-help>
        </div>
      </section>

      <section>
        <h3>
          How you'll sign in
        </h3>

        <se-fe-form-field [seFeDataConfig]="formConfig.email">
          <se-fe-form-field-text formControlName="email" seFeDataType="email" [seFeDataComfy]="comfy"
            seFeDataInputMode="email" seFeDataAutoComplete="email"></se-fe-form-field-text>
        </se-fe-form-field>

        <se-fe-form-field [seFeDataConfig]="formConfig.phone">
          <se-fe-form-field-text formControlName="phone" seFeDataPlaceholder="(___) ___-____" [seFeDataComfy]="comfy"
            seFeDataInputMode="tel" seFeDataAutoComplete="tel-national"></se-fe-form-field-text>
          <se-fe-form-control-help>
            This will help you sign in.
            <button type="button" class="popover-link" seFePopoverTrigger="phoneLearnMore" seFeLink>
              Learn more
            </button>
            <se-fe-popover seFePopoverName="phoneLearnMore">
              <p>
                SportsEngine will use your phone number only for account verification and security purposes.
              </p>
              <p>
                You can choose later whether to provide this number to your organization for other purposes.
              </p>
            </se-fe-popover>
          </se-fe-form-control-help>
        </se-fe-form-field>
      </section>

      <section>
        <se-fe-button seFeDataEmphasis="high" seFeDataType="submit" [seFeDataIsLoading]="submitter.submitting"
          [seFeDataFullWidth]="true">
          Continue
        </se-fe-button>
      </section>

    </form>

    <se-po-household-setup-already-have-account></se-po-household-setup-already-have-account>
  </div>
</div>
